<template>
    <div class="background">
        <div class="text1">在线客服（工作日8:30-17:30）</div>
        <div class="text2">专属商务经理在线解答，提供专业的解决方案</div>
        <div class="chatCtn" id="chatContent">
            <span v-for="(item,i) in messageList" :key="'chatContent'+i">
                <!--客服-->
                <div v-if="item.identity==1||item.identity==0" class="serviceChat">
                    <div class="servicerTip">
                        <img src="../../assets/onlineService/机器人.png" style="position: absolute;width: 32px;"/>
                        <div class="servicerTxt1">
                            <span v-if="item.identity==1">遥感商城商务经理</span>
                            <span v-if="item.identity==0">智能客服</span>
                        </div>
                        <div class="servicerTxt2" v-if="item.createTime&&item.identity==1">{{item.createTime}}</div>
                    </div>
                    <!--文本内容-->
                    <div v-if="(item.type==0||item.type==3||item.type==4)&&item.identity==1" class="serviceContent" v-html="renderRichContent(item.content)"></div>
                    <div v-if="(item.type==0||item.type==3||item.type==4)&&item.identity==0" class="serviceContent" v-html="item.content"></div>
                </div>
                <!--用户-->
                <div v-if="item.identity==2" class="customChat">
                    <div v-if='item.createTime' class='customTxt'>{{item.createTime}}</div>
                    <div v-if="item.type==4" class="customTip" v-html="renderRichContent(item.content)"></div>
                </div>
            </span>
        </div>
        <div class="chatInput">
            <div class="inputCtn" ref="editor" contenteditable="true" placeholder="请输入您的问题，如：如何购买吉林一号卫星影像？"
                @input="onEditorInput" @paste="onPaste" @keydown.enter.prevent="sendRichMessage" >
            </div>
            <img src="../../assets/onlineService/表情.png" alt="" @click="showExpressions=!showExpressions" 
                style="position: absolute;top: 106px;left: 24px;width: 24px;cursor: pointer;z-index: 2;">
            <div class="extendOperateImg">
                <input ref="referenceUpload" class="fileImage" type="file" value="" accept="image/*" v-on:change="insertImage"/>
                <img src="../../assets/onlineService/图片.png" alt=""
                    style="position: absolute;top: 0px;left:0px;width: 24px;cursor: pointer;">
            </div>
            <!--表情包-->
            <div v-if="showExpressions" class="expressionCtn">
                <div class="face">
                    <ul>
                        <li v-for="(item, index) in expressions" :key="index">
                            <img  v-bind:src="item.image" v-bind:title="item.title"  @click="insertExpression(item.image, item.title)"/>
                        </li>
                    </ul>
                </div>
                <div @click="showExpressions=false" class="sendButton">关闭</div>
            </div>
            <img src="../../assets/onlineService/发送.png" alt="" @click="sendRichMessage" style="position: absolute;width: 24px;top: 100px;right: 16px;cursor: pointer;">
        </div>
        <!-- 图片模态框 -->
        <div class="image-modal" :class="{ active: modalActive }" @click.self="closeModal">
            <button class="modal-close" @click="closeModal">×</button>
            <button class="modal-nav modal-prev" v-if="hasPrev" @click="showPrev">❮</button>
            <button class="modal-nav modal-next" v-if="hasNext" @click="showNext">❯</button>
            <div class="image-counter" v-if="modalImages.length > 1">
                {{ currentIndex + 1 }} / {{ modalImages.length }}
            </div>
            <div class="modal-content">
                <img :src="currentImage" class="modal-image" ref="modalImage">
            </div>
        </div>
    </div>
</template>
<script>
const robotReply=require('./robotReply.json')
// 欢迎语：进入会话时由 robotWelcome() 展示一次；命中相同内容的关键字回复时跳过，避免重复
const WELCOME_CONTENT = "您好，很高兴为您服务，请问有什么可以为您效劳?"
export default {
    name: "",
    data(){
        return {
            userId:'',
            messageList:[],
            socket:null,//socket对象
            wsCount:0,
            convertion:{},
            heartTimer:null,
            editorContent:'',
            showExpressions:false,
            expressions: [
                {
                title: "[呵呵]",
                image: require("../../assets/onlineService/Expression/smilea_thumb.gif"),
                },
                {
                title: "[嘻嘻]",
                image: require("../../assets/onlineService/Expression/tootha_thumb.gif"),
                },
                {
                title: "[哈哈]",
                image: require("../../assets/onlineService/Expression/laugh.gif"),
                },
                {
                title: "[可爱]",
                image: require("../../assets/onlineService/Expression/tza_thumb.gif"),
                },
                {
                title: "[可怜]",
                image: require("../../assets/onlineService/Expression/kl_thumb.gif"),
                },
                {
                title: "[挖鼻屎]",
                image: require("../../assets/onlineService/Expression/kbsa_thumb.gif"),
                },
                {
                title: "[吃惊]",
                image: require("../../assets/onlineService/Expression/cj_thumb.gif"),
                },
                {
                title: "[害羞]",
                image: require("../../assets/onlineService/Expression/shamea_thumb.gif"),
                },
                {
                title: "[挤眼]",
                image: require("../../assets/onlineService/Expression/zy_thumb.gif"),
                },
                {
                title: "[闭嘴]",
                image: require("../../assets/onlineService/Expression/bz_thumb.gif"),
                },
                {
                title: "[鄙视]",
                image: require("../../assets/onlineService/Expression/bs2_thumb.gif"),
                },
                {
                title: "[爱你]",
                image: require("../../assets/onlineService/Expression/lovea_thumb.gif"),
                },
                {
                title: "[泪]",
                image: require("../../assets/onlineService/Expression/sada_thumb.gif"),
                },
                {
                title: "[偷笑]",
                image: require("../../assets/onlineService/Expression/heia_thumb.gif"),
                },
                {
                title: "[亲亲]",
                image: require("../../assets/onlineService/Expression/qq_thumb.gif"),
                },
                {
                title: "[生病]",
                image: require("../../assets/onlineService/Expression/sb_thumb.gif"),
                },
                {
                title: "[太开心]",
                image: require("../../assets/onlineService/Expression/mb_thumb.gif"),
                },
                {
                title: "[懒得理你]",
                image: require("../../assets/onlineService/Expression/ldln_thumb.gif"),
                },
                {
                title: "[右哼哼]",
                image: require("../../assets/onlineService/Expression/yhh_thumb.gif"),
                },
                {
                title: "[左哼哼]",
                image: require("../../assets/onlineService/Expression/zhh_thumb.gif"),
                },
                {
                title: "[嘘]",
                image: require("../../assets/onlineService/Expression/x_thumb.gif"),
                },
                {
                title: "[衰]",
                image: require("../../assets/onlineService/Expression/cry.gif"),
                },
                {
                title: "[委屈]",
                image: require("../../assets/onlineService/Expression/wq_thumb.gif"),
                },
                {
                title: "[吐]",
                image: require("../../assets/onlineService/Expression/t_thumb.gif"),
                },
                {
                title: "[打哈气]",
                image: require("../../assets/onlineService/Expression/k_thumb.gif"),
                },
                {
                title: "[抱抱]",
                image: require("../../assets/onlineService/Expression/bba_thumb.gif"),
                },
                {
                title: "[怒]",
                image: require("../../assets/onlineService/Expression/angrya_thumb.gif"),
                },
                {
                title: "[疑问]",
                image: require("../../assets/onlineService/Expression/yw_thumb.gif"),
                },
                {
                title: "[馋嘴]",
                image: require("../../assets/onlineService/Expression/cza_thumb.gif"),
                },
                {
                title: "[拜拜]",
                image: require("../../assets/onlineService/Expression/88_thumb.gif"),
                },
                {
                title: "[思考]",
                image: require("../../assets/onlineService/Expression/sk_thumb.gif"),
                },
                {
                title: "[汗]",
                image: require("../../assets/onlineService/Expression/sweata_thumb.gif"),
                },
                {
                title: "[困]",
                image: require("../../assets/onlineService/Expression/sleepya_thumb.gif"),
                },
                {
                title: "[睡觉]",
                image: require("../../assets/onlineService/Expression/sleepa_thumb.gif"),
                },
                {
                title: "[钱]",
                image: require("../../assets/onlineService/Expression/money_thumb.gif"),
                },
                {
                title: "[失望]",
                image: require("../../assets/onlineService/Expression/sw_thumb.gif"),
                },
                {
                title: "[酷]",
                image: require("../../assets/onlineService/Expression/cool_thumb.gif"),
                },
                {
                title: "[花心]",
                image: require("../../assets/onlineService/Expression/hsa_thumb.gif"),
                },
                {
                title: "[哼]",
                image: require("../../assets/onlineService/Expression/hatea_thumb.gif"),
                },
                {
                title: "[鼓掌]",
                image: require("../../assets/onlineService/Expression/gza_thumb.gif"),
                },
                {
                title: "[晕]",
                image: require("../../assets/onlineService/Expression/dizzya_thumb.gif"),
                },
                {
                title: "[悲伤]",
                image: require("../../assets/onlineService/Expression/bs_thumb.gif"),
                },
            ],
            modalActive: false,
            modalImages: [],
            currentIndex: 0,

        };
    },
    computed:{
        hasContent:function () {
            return this.editorContent.trim().length > 0;
        },
        currentImage() {
            return this.modalImages[this.currentIndex] || '';
        },
        hasPrev() {
            return this.currentIndex > 0;
        },
        hasNext() {
            return this.currentIndex < this.modalImages.length - 1;
        }
    },
    methods:{
        // 富文本片段（processEditorContent 输出）转成用于关键字匹配的纯文本
        fragmentsToPlainText(fragments) {
            if (!Array.isArray(fragments)) return '';
            return fragments
                .map(f => {
                    if (!f) return '';
                    if (f.type === 'text') return f.content || '';
                    // 表情：用 title / content 参与匹配（两者取其一）
                    if (f.type === 'emoji') return f.title || f.content || '';
                    return '';
                })
                .join('');
        },
        normalizeMatchText(text) {
            return String(text || '')
                .replace(/\s+/g, '') // 去空白
                .toLowerCase(); // 英文不区分大小写
        },
        // 根据用户输入文本在 robotReply.json 中找第一条命中的 Reply（Answer 支持逗号/中文逗号分隔多个关键字）
        findRobotReplyByText(userText) {
            const normalizedUserText = this.normalizeMatchText(userText);
            if (!normalizedUserText) return null;
            if (!Array.isArray(robotReply)) return null;

            for (const item of robotReply) {
                const answerRaw = item && (item.Answer || item.answer);
                const replyRaw = item && (item.Reply || item.reply);
                if (!answerRaw || !replyRaw) continue;

                const keywords = String(answerRaw)
                    .split(/[,，]/g)
                    .map(s => s.trim())
                    .filter(Boolean);

                for (const kw of keywords) {
                    const normalizedKw = this.normalizeMatchText(kw);
                    if (normalizedKw && normalizedUserText.includes(normalizedKw)) {
                        return String(replyRaw);
                    }
                }
            }
            return null;
        },
        pushRobotReply(replyHtml) {
            const timestamp = new Date().getTime();
            const msg = {
                id: this.userId + '_robot_' + timestamp,
                sendId: null,
                receiveId: this.userId,
                content: replyHtml, // 机器人/智能客服内容允许 v-html
                identity: 0, // 0 机器人（智能客服）
                type: 3, // 3 机器人回复
                state: 0,
                createTime: null,
            };
            this.messageList.push(msg);
            this.toBottom(200);
        },
        // 判断回复是否与欢迎语内容相同（仅比较中文/字母/数字，忽略标点和空白差异）
        isSameAsWelcome(text) {
            const strip = (s) => String(s || '').replace(/[^一-龥A-Za-z0-9]/g, '');
            return strip(text) === strip(WELCOME_CONTENT);
        },
        initSocket(){
            if (typeof WebSocket === "undefined") {
                alert("您的浏览器不支持socket");
            } else {
                if(this.socket){
                    this.socket.close();
                    this.socket=null;
                }
                let WSUrl = 'wss://www.jl1mall.com/chat_back/websocket/'+this.userId;
                // let WSUrl = 'wss://jlyhw.jl1.cn//chat_back/websocket/'+this.userId;
                // 实例化socket
                this.socket = new WebSocket(`${WSUrl}`);
                // 监听socket连接
                this.socket.onopen = this.open;
                // 监听socket错误信息
                this.socket.onerror = this.error;
                // 监听socket消息
                this.socket.onmessage = this.getMessage;
                this.socket.onsend = this.send;
                // 关闭socket
                this.socket.onclose = this.close;
            }
        },
        open() {
            console.log("socket连接成功");
            console.log(new Date())
            this.wsCount=0;
            //请求历史消息
            this.requestHistory(this.userId);
            console.log(this.userId);
            //成功后开始心跳检测
            this.heartTimer=setInterval(()=>{
                this.heartTest();
            },5000)
        },
        error() {
            const timer = setTimeout(() => {
                this.initSocket();
                this.wsCount++;
            }, 5000);
            if (this.wsCount > 4) {
                clearTimeout(timer);
            }
        },
        send(Data) {},
        close() {
            if(this.heartTimer){
                clearInterval(this.heartTimer);
                this.heartTimer=null;
            }
        },
        getMessage(msg) {
            console.log(msg);
            let message=JSON.parse(msg.data);
            if(message.type=='message') {
                this.getRealTimeMessage(message.message);
            }
            else if(message.type=='history'){
                this.historyMessages(message.message)
            }
        },
        heartTest(){
            if(this.socket.readyState){
                if (this.socket.readyState === WebSocket.OPEN) {
                    this.socket.send(JSON.stringify({type:'ping',message:{}}));
                }
            }
        },
        requestHistory(userId){
            this.convertion={
                type:'requsetHistory',
                message:{
                    openUser:userId,//打开的用户
                }
            }
            this.socket.send(JSON.stringify(this.convertion));
        },
        getRealTimeMessage:function(message){
            this.messageList.push(message);
            this.toBottom(200);
        },
        historyMessages(messages){
            this.messageList=messages;
            this.toBottom(200);
            this.robotWelcome();
        },
        toBottom(time) {
            setTimeout(() => {
                let chatContent = document.getElementById("chatContent");
                if (chatContent != null) {
                    let scrollHeight = chatContent.scrollHeight;
                    chatContent.scrollTop = scrollHeight;
                }
            }, time);
            clearTimeout();
        },
        robotWelcome(){
            let timestamp=new Date().getTime();
            this.infoTemplate = {
                id:this.userId+timestamp,
                sendId: null, //发送者 Id
                receiveId: this.userId, //接收者 Id
                content: WELCOME_CONTENT,
                identity: 0, //发送者身份：0 机器人，1 客服员，2.会员
                type: 0, //信息类型 ：0 文本，1 图片，2 表情，3 机器人回复
                state: 0, //信息发送状态:0未读，1已读，2发送失败
                createTime: null, //服务器收到消息时间戳
            }
            this.messageList.push(this.infoTemplate)
            this.toBottom(200);
        },
        // 渲染富文本内容
        renderRichContent(content) {
            try {
                const fragments = JSON.parse(content);
                let html = '';
                fragments.forEach(fragment => {
                    if (fragment.type === 'text') {
                        html += `<span>${this.escapeHtml(fragment.content)}</span>`;
                    } else if (fragment.type === 'br') {
                        html += `<br/>`;
                    } else if (fragment.type === 'emoji') {
                        html += `<img src="${fragment.content}" class="emoji" title="${fragment.title || ''}" />`;
                    } else if (fragment.type === 'image') {
                        const safeUrl = this.escapeHtml(fragment.content);
                        const allImages = this.getAllImagesFromContent(content);
                        const safeImagesJson = this.escapeHtml(JSON.stringify(allImages));
                        html += `<div class="rich-image-line"><img src="${safeUrl}" class="rich-image" data-src="${safeUrl}" style="max-width: 200px;" onclick="window.vueApp.openImage('${safeUrl}', '${safeImagesJson}')"></div>`;
                    }
                });
                return html;
            } catch (e) {
                return this.escapeHtml(content);
            }
        },
        // HTML转义
        escapeHtml(text) {
            if (typeof text !== 'string') {
                text = String(text);
            }
            const div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML.replace(/'/g, '&#39;').replace(/"/g, '&quot;').replace(/\\/g, '&#92;');
        },
        // 从内容中提取所有图片
        getAllImagesFromContent(content) {
            try {
                const fragments = JSON.parse(content);
                return fragments.filter(f => f.type === 'image').map(f => f.content);
            } catch (e) {
                return [];
            }
        },
        onEditorInput() {
            this.editorContent = this.$refs.editor.innerHTML;
        },
        onPaste(e) {
            // 处理粘贴的图片
            const items = e.clipboardData.items;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image') !== -1) {
                    const file = items[i].getAsFile();
                    this.uploadImage(file);
                    e.preventDefault();
                }
            }
        },
        uploadImage(file) {
            const placeholderImg = document.createElement('div');
            // 输入框内：图片/占位符按“表情”一样流式排列，放不下自动换行
            placeholderImg.innerHTML = '<div style="display:inline-block; width:100px; height:80px; background:#f0f0f0; border-radius:4px; text-align:center; line-height:80px; color:#999; margin:0 2px; vertical-align:middle;">上传中...</div>';
            this.insertNodeAtCaret(placeholderImg);
            let formData = new FormData();
            formData.append("fileList", file);
            this.axios.post("/chat_back/chat/message/uploadFile", formData).then((res)=>{
                // 获取服务器返回的图片URL
                const imageUrl = res.data.data[0];
                // 替换占位符为实际图片
                const img = document.createElement('img');
                img.src = imageUrl;
                img.className = 'image';
                img.setAttribute('data-type', 'image');
                placeholderImg.replaceWith(img);
                this.onEditorInput();
            })
        },
        // 在光标位置插入节点
        insertNodeAtCaret(node) {
        const editor = this.$refs.editor;
        const sel = window.getSelection();
        // 检查编辑器是否获得焦点
        const isEditorFocused = document.activeElement === editor;
        // 如果编辑器没有焦点或者没有有效的选择范围，将内容添加到末尾
        if (!isEditorFocused || !sel || sel.rangeCount === 0 || !sel.getRangeAt(0).collapsed) {
            // 创建范围并设置到编辑器末尾
            const range = document.createRange();
            range.selectNodeContents(editor);
            range.collapse(false); // false表示移动到末尾
            // 插入节点
            range.insertNode(node);
            // 移动光标到插入内容之后
            const newRange = document.createRange();
            newRange.setStartAfter(node);
            newRange.collapse(true);
            // 更新选择
            sel.removeAllRanges();
            sel.addRange(newRange);
        } else {
            const range = sel.getRangeAt(0);
            // 检查选择范围是否在编辑器内
            if (!editor.contains(range.commonAncestorContainer)) {
            // 创建范围并设置到编辑器末尾
            const endRange = document.createRange();
            endRange.selectNodeContents(editor);
            endRange.collapse(false);
            endRange.insertNode(node);
            // 移动光标到插入内容之后
            const newRange = document.createRange();
            newRange.setStartAfter(node);
            newRange.collapse(true);
            sel.removeAllRanges();
            sel.addRange(newRange);
            } else {
            range.deleteContents();
            range.insertNode(node);
            range.collapse(false);
            // 移动光标到插入内容之后
            const newRange = document.createRange();
            newRange.setStartAfter(node);
            newRange.collapse(true);
            sel.removeAllRanges();
            sel.addRange(newRange);
            }
        }
        // 聚焦编辑器
        editor.focus();
        },
        sendRichMessage() {
            if (!this.hasContent) { return; }
                const editor = this.$refs.editor;
                const content = this.processEditorContent(editor);
            if (!content || content.length === 0) return;
                const timestamp = new Date().getTime();
                this.infoTemplate = {
                    id: this.userId + timestamp,
                    sendId: this.userId,
                    receiveId: null,
                    content: JSON.stringify(content), // 序列化内容
                    identity: 2,
                    type: 4, // 富文本类型
                    state: 0,
                    createTime: null,
                };
            this.messageList.push(this.infoTemplate)
            this.convertion={type:'message',message:this.infoTemplate}
            this.socket.send(JSON.stringify(this.convertion));
            this.toBottom(200);

            // 关键字命中 robotReply.json 时，自动触发“智能客服”回复，并保存到对话
            try {
                const userPlainText = this.fragmentsToPlainText(content);
                const reply = this.findRobotReplyByText(userPlainText);
                if (reply) {
                    // 欢迎语已在进入会话时由 robotWelcome() 展示过，命中相同内容时跳过，避免重复
                    if (!this.isSameAsWelcome(reply)) {
                        // 稍微延迟，模拟客服“正在输入”的感觉，同时避免与用户消息同时渲染抖动
                        setTimeout(() => this.pushRobotReply(reply), 200);
                    }
                }
            } catch (e) {
                // 匹配失败不影响正常发消息
                console.warn('robotReply match failed:', e);
            }

            editor.innerHTML = '';
            this.editorContent = '';
        },
        processEditorContent(editor) {
            const nodes = editor.childNodes;
            const content = [];
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if (node.nodeType === Node.TEXT_NODE) {
                    const text = node.textContent.trim();
                    if (text) {
                        content.push({type: 'text',content: text});
                    }
                }
                else if (node.nodeType === Node.ELEMENT_NODE) {
                    // 换行
                    if (node.tagName === 'BR') {
                        // 避免连续多个 br 造成太多空行
                        const last = content[content.length - 1];
                        if (!last || last.type !== 'br') {
                            content.push({ type: 'br' });
                        }
                        continue;
                    }
                    if (node.tagName === 'IMG' && node.classList.contains('emoji')) {
                        content.push({type: 'emoji',content: node.src,title: node.getAttribute('data-title')});
                    }else if (node.tagName === 'IMG' && node.classList.contains('image')) {
                        content.push({type: 'image',content: node.src});
                    }
                    else {
                        const text = node.textContent.trim();
                        if (text) {
                            content.push({type: 'text',content: text});
                        }
                    }
                }
            }
            return content;
        },
        // 插入表情
        insertExpression(imgSrc, title) {
            const img = document.createElement('img');
            img.src = imgSrc;
            img.className = 'emoji';
            img.setAttribute('data-type', 'emoji');
            img.setAttribute('data-title', title);
            this.insertNodeAtCaret(img);
            this.showExpressions = false;
            this.onEditorInput();
        },
        insertImage(e) {
            const file = e.target.files[0];
            if (file) {
                this.uploadImage(file);
            }
            // 清空input，允许再次选择相同文件
            e.target.value = '';
        },
        openImage(imageSrc, imagesJson) {
            try {
                // 解析JSON字符串
                let allImages = [];
                if (imagesJson && typeof imagesJson === 'string') {
                // 先解码HTML实体，然后解析JSON
                const decodedJson = this.decodeHtml(imagesJson);
                allImages = JSON.parse(decodedJson);
                } else if (Array.isArray(imagesJson)) {
                allImages = imagesJson;
                }
                // 确保allImages是数组
                if (!Array.isArray(allImages)) {
                allImages = [imageSrc];
                }
                // 如果没有图片，使用当前图片
                if (allImages.length === 0) {
                allImages = [imageSrc];
                }
                this.modalImages = allImages;
                this.currentIndex = this.modalImages.indexOf(imageSrc);
                // 如果找不到图片，设置为第一张
                if (this.currentIndex === -1) {
                this.currentIndex = 0;
                }
                this.modalActive = true;
                // 阻止背景滚动
                document.body.style.overflow = 'hidden';
            } catch (e) {
                console.error('打开图片失败:', e);
                // 出错时使用单张图片
                this.modalImages = [imageSrc];
                this.currentIndex = 0;
                this.modalActive = true;
                document.body.style.overflow = 'hidden';
            }
        },
        decodeHtml(html) {
            const txt = document.createElement('textarea');
            txt.innerHTML = html;
            return txt.value;
        },
        // 关闭模态框
        closeModal() {
            this.modalActive = false;
            document.body.style.overflow = '';
        },
        showPrev() {
            if (this.hasPrev) {
                this.currentIndex--;
            }
        },
        showNext() {
            if (this.hasNext) {
                this.currentIndex++;
            }
        },
    },
    mounted(){
        this.userId=localStorage.getItem('chatUserId');
        this.initSocket();
        this.messageList=[]
        window.vueApp = this
        // 添加键盘事件监听
        window.addEventListener('keydown', (e) => {
            if (this.modalActive) {
                if (e.key === 'Escape') {
                    this.closeModal();
                } else if (e.key === 'ArrowLeft' && this.hasPrev) {
                    this.showPrev();
                } else if (e.key === 'ArrowRight' && this.hasNext) {
                    this.showNext();
                }
            }
        });
    },
};
</script>
<style scoped>
.background{
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: linear-gradient( 90deg, #FFFFFF 0%, #E6F7FF 100%);
}
.text1{
    position: absolute;
    top: 39px;
    left: 40px;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
}
.text2{
    position: absolute;
    top: 40px;
    left: 274px;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #595959;
    line-height: 22px;
}
.chatCtn{
    position: absolute;
    width: 1176px;
    height: calc(100% - 320px);
    top: 102px;
    left: calc(50% - 588px);
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none;     
    -ms-overflow-style: none; 
}
.chatCtn::-webkit-scrollbar {
    display: none;  /* 隐藏滚动条 */
}
.serviceChat{
    position: relative;
    width: 100%;
    height: auto;
}
.servicerTip{
    position: relative;
    width: 100%;
    height: 32px;
    margin-bottom: 16px;
}
.servicerTxt1{
    position: absolute;
    top: 4px;
    left: 48px;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
}
.servicerTxt2{
    position: absolute;
    top: 7px;
    left: 200px;
    width: auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
}
.serviceContent{
    position: relative;
    width: fit-content;
    max-width: 876px;
    height: auto;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    padding: 8px 16px;
    border-radius: 4px;
    margin-bottom: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
    text-align: justify;
    /* 让长 URL / 英文单词能够换行，避免一行过长导致 text-align: justify 把中文字符撑开 */
    overflow-wrap: break-word;
    word-break: break-all;
    word-wrap: break-word;
}
::v-deep .serviceContent img {
  max-width: 200px !important;
  width: auto !important;
  height: auto !important;
  display: inline-block !important;
  vertical-align: middle;
  border-radius: 4px;
  margin: 2px;
}

/* 防止其他样式覆盖 */
.serviceContent * {
  max-width: 100% !important;
}
.customChat{
    position: relative;
    width: 100%;
    height: auto;
}
.customTip{
    position: relative;
    margin-left: auto;
    width: fit-content;
    max-width: 876px;
    height: auto;
    background: #1890FF;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 22px;
    text-align: justify;
    margin-bottom: 16px;
    padding: 8px 16px;
    /* 让长 URL / 英文单词能够换行，避免一行过长导致 text-align: justify 把中文字符撑开 */
    overflow-wrap: break-word;
    word-break: break-all;
    word-wrap: break-word;
}
::v-deep .customTip img {
  max-width: 200px !important;
  width: auto !important;
  height: auto !important;
  display: inline-block !important;
  vertical-align: middle;
  border-radius: 4px;
  margin: 2px;
}

/* 防止其他样式覆盖 */
.customTip * {
  max-width: 100% !important;
}
.customTxt{
    position: relative;
    margin-left: auto;  
    width: 500px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
    margin-bottom: 16px;
    text-align: right;
    padding-right: 16px;
}
.chatInput{
    position: absolute;
    bottom: 40px;
    left: calc(50% - 588px);
    width: 1176px;
    height: 154px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
}
.inputCtn{
    position: relative;
    margin-top: 24px;
    margin-left: 24px;
    width: 1128px;
    height: 66px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    line-height: 22px;
    text-align: justify;
    overflow-x: hidden;
    overflow-y: auto;
    border: none;
    outline: none;
    overflow-wrap: break-word;
    resize: none;
}
.inputCtn:empty::before {
    content: attr(placeholder);  
    color: #CCCCCC;            
    display: block;            
    pointer-events: none;    
}
.inputCtn:focus:empty::before {
    content: '';               
}
/* 使用更具体的选择器确保样式优先级 */
::v-deep .inputCtn img.emoji {
  width: 20px !important;
  height: 20px !important;
  display: inline-block !important;
  vertical-align: middle;
  margin: 0 2px;
}

::v-deep .inputCtn img.image {
  max-width: 200px !important;
  width: auto !important;
  height: auto !important;
  display: inline-block !important; /* 输入框：像表情一样顺序排列 */
  vertical-align: middle;
  border-radius: 4px;
  margin: 0 2px; /* 左右间隔和表情一致 */
}

/* 聊天内容区：让渲染出来的图片也独占一行 */
::v-deep .serviceContent .rich-image-line,
::v-deep .customTip .rich-image-line {
  display: block;
  margin: 4px 0;
}

::v-deep .serviceContent .rich-image-line img,
::v-deep .customTip .rich-image-line img {
  display: block;
  max-width: 200px;
  width: auto;
  height: auto;
  border-radius: 4px;
}

/* 防止其他样式覆盖 */
.inputCtn * {
  max-width: 100% !important;
}
.expressionCtn{
  position:absolute;
  left: -360px;
  bottom:0px;
  width: 350px;
  height:190px;
  background: #ffffff;
  box-shadow: 1px 1px 5px 1px rgba(0,0,0,0.1);
  border-radius: 5px;
  .face {
    width: 101%;
  }

  .face ul {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 8px;
    box-sizing: border-box;
  }

  .face ul li {
    width: 30px;
    height: 30px;
    list-style-type: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sendButton{ 
    position:absolute;
    right:8px;
    bottom:8px;
    width: 72px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #0066CC;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    cursor:pointer;
  }
}

.extendOperateImg{
    top: 106px;
    left: 72px;
    position: absolute;
    width: 24px;
    height: 24px;
    cursor: pointer;
}
.fileImage{
    z-index: 1;
    position: absolute;
    width: 20px;
    height:20px;
    opacity: 0;
    cursor:pointer;
}
</style>
<style scoped>
/* 图片模态框样式 */
.image-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s;
    }

    .image-modal.active {
      opacity: 1;
      pointer-events: auto;
    }

    .modal-content {
      position: relative;
      max-width: 90%;
      max-height: 90%;

    }
    .modal-image {
      max-width: 100%;
      max-height: 80vh;
      border-radius: 4px;
      box-shadow: 0 5px 25px rgba(0, 0, 0, 0.5);
    }
    .modal-close {
      position: absolute;
      top: 20px;
      right: 20px;
      background: none;
      border: none;
      color: white;
      font-size: 30px;
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .modal-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255, 255, 255, 0.2);
      border: none;
      color: white;
      font-size: 24px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
    }
    .modal-nav:hover {
      background: rgba(255, 255, 255, 0.3);
    }
    .modal-prev {
      left: 20px;
    }
    .modal-next {
      right: 20px;
    }
    .image-counter {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      text-align: center;
      color: white;
      font-size: 16px;
    }
</style>